import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiLogOut, FiSettings, FiBarChart2, FiShield } from 'react-icons/fi';
import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/dashboard" className="navbar-brand">
            <img 
              src="/S-Collect-LOGO.png" 
              alt="SCollect" 
              style={{ height: '40px', width: 'auto' }}
            />
          </Link>
          
          <ul className="navbar-nav">
            <li>
              <Link 
                to="/dashboard" 
                className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
              >
                <FiBarChart2 style={{ marginRight: '5px' }} />
                Dashboard
              </Link>
            </li>
            
            <li>
              <Link 
                to="/settings" 
                className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
              >
                <FiSettings style={{ marginRight: '5px' }} />
                Settings
              </Link>
            </li>
            
            {isAdmin && (
              <li>
                <Link 
                  to="/admin" 
                  className={`nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}
                >
                  <FiShield style={{ marginRight: '5px' }} />
                  Admin
                </Link>
              </li>
            )}
            
            <li>
              <ThemeToggle />
            </li>
            
            <li>
              <span className="nav-link" style={{ color: '#666' }}>
                Welcome, {user?.username}
              </span>
            </li>
            
            <li>
              <button 
                onClick={logout}
                className="btn btn-secondary btn-small"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FiLogOut style={{ marginRight: '5px' }} />
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
